import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, UtensilsCrossed } from 'lucide-react';
import { Button } from '../ui/button';

export function DiningPreview() {
  return (
    <section className="section-padding bg-muted/30" data-testid="dining-preview-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="overline text-emerald-700 dark:text-emerald-400 mb-3">Culinary Excellence</p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">
              Dining & <span className="text-emerald-700 dark:text-emerald-400">Experiences</span>
            </h2>
            <p className="text-muted-foreground mb-8 leading-relaxed">
              Savor the authentic flavors of Odisha crafted by our expert chefs. From traditional tribal delicacies to international cuisines, every meal is a celebration of taste and tradition.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-sm bg-emerald-100 dark:bg-emerald-900/50 flex items-center justify-center flex-shrink-0">
                  <UtensilsCrossed className="w-5 h-5 text-emerald-700 dark:text-emerald-400" />
                </div>
                <div>
                  <h4 className="font-serif text-foreground mb-1">Local Flavours</h4>
                  <p className="text-sm text-muted-foreground">Authentic Odia cuisine</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-sm bg-emerald-100 dark:bg-emerald-900/50 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5 text-emerald-700 dark:text-emerald-400" />
                </div>
                <div>
                  <h4 className="font-serif text-foreground mb-1">24/7 Service</h4>
                  <p className="text-sm text-muted-foreground">In-room dining available</p>
                </div>
              </div>
            </div>

            <Link to="/dining">
              <Button
                className="btn-emerald"
                data-testid="explore-dining-btn"
              >
                Explore Our Menu
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </motion.div>

          {/* Right Images */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            {/* Main Image */}
            <div className="relative rounded-sm overflow-hidden aspect-[4/3]">
              <img
                src="https://images.pexels.com/photos/29685054/pexels-photo-29685054.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Creamy butter chicken in copper pan - signature Indian cuisine"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Floating Image */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="absolute -bottom-8 -left-8 w-48 h-48 rounded-sm overflow-hidden shadow-2xl border-4 border-background hidden md:block"
            >
              <img
                src="https://images.unsplash.com/photo-1716535232842-d10da4eb33d5?w=400&h=400&fit=crop"
                alt="Authentic desi chicken curry"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </motion.div>

            {/* Decorative Element */}
            <div className="absolute -top-4 -right-4 w-24 h-24 border-2 border-gold rounded-sm -z-10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
